/**
 * Checks if the device is a touch device.
 * @returns {boolean}
 */export var isTouchDevice=function isTouchDevice(){try{document.createEvent('TouchEvent');return true;}catch(e){return false;}};